// removed by extract-text-webpack-plugin
module.exports = {"fr":"_2tSf","business-link":"_3IwO","footer-txt":"_2mwO","ptm-logo":"_1vA3","txt-center":"_3pzL","m-hide-im":"_2rmj"};


//////////////////
// WEBPACK FOOTER
// ./form/components/footerlink/style.css
// module id = i7CM
// module chunks = 4